// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__3hU3F","item":"styles_item__1QDbK"};